import { ArticleHeading5 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { QuickLinkItem } from './internal/components/QuickLinkItem';
import { QuickLinksMoreItemsButton } from './internal/components/QuickLinksMoreItemsButton';
import { QuickLinksProps } from './types';

import styles from './QuickLinks.css';

export const QuickLinks: FC<QuickLinksProps> = props => {
  const { quickLinks, moreItemsButton, columns, trackQuickLinkClick } = props;

  return (
    <div className={styles['container']} data-testid="quick-links">
      <ArticleHeading5>Рекомендуем посмотреть</ArticleHeading5>
      <ul className={clsx(styles['list'], styles[`list-columns-${columns}`])} data-testid="quick-links.list">
        {quickLinks.map(link => (
          <li className={styles['item']} data-testid="quick-links.list-item" key={link.id}>
            <QuickLinkItem
              offersCount={link.offersCount}
              paddingLink={8}
              title={link.title}
              track={(): void => trackQuickLinkClick(link)}
              url={link.url}
            />
          </li>
        ))}
        {!!moreItemsButton && (
          <li className={styles['item']} data-testid="quick-links.list-item">
            <QuickLinksMoreItemsButton
              dataTestId={moreItemsButton.dataTestId}
              icon={moreItemsButton.icon}
              title={moreItemsButton.title}
              onClick={moreItemsButton.onClick}
            />
          </li>
        )}
      </ul>
    </div>
  );
};
